<template>
  <breadCrumbs title="Dropdown" main="UI Kits" title1="Dropdown" />
  <div class="container-fluid dropdown-page">
    <div class="row">
      <basicDropdown />
      <colorDropdown />
      <splitDropdown />
      <roundedDropdown />
      <dropdown />
    </div>
  </div>
</template>
<script>
import colorDropdown from "./colorDropdown.vue"
import basicDropdown from "./basicDropdown.vue"
import splitDropdown from "./splitDropdown.vue"
import roundedDropdown from "./roundedDropdown.vue"
import dropdown from "./dropdownPage.vue"
export default {
  components: {
    colorDropdown,
    basicDropdown,
    splitDropdown,
    roundedDropdown,
    dropdown
  }
};
</script>